window.addEventListener('DOMContentLoaded', event => {

	const autocompleteModalValue = (modalSort, modalEl) => {
		modalEl.addEventListener('show.bs.modal', () => {
			const inputs = document.getElementsByClassName('form-control');
			let previousValueInput = null;
			let currentValueInput = null;
			[...inputs].forEach(input => {
			if (input.name == modalSort && input.classList.contains('search-field')) {
				previousValueInput = input;
			} else if (input.name === modalSort) {
				currentValueInput = input;
			}
		})
		if (previousValueInput !== null && currentValueInput !== null) {
				currentValueInput.value = previousValueInput.value;
			}
		})
	}

	// Search for modals in the DOM and autofill value from search field.
	const modals = document.getElementsByClassName('modal');
	[...modals].forEach(modal => {
		if (modal.id.includes('-modal')) {
			let modalSort = modal.id;
			modalSort = modalSort.replace('-modal', '');
			autocompleteModalValue(modalSort, modal);
		}
	})
});

async function onClickSaveButton(buttonId, formId, modalId, ajaxFilename, errorElementId = '', defaultInputNameObj = {}) {
	const saveButton = document.getElementById(buttonId);
	if (saveButton) {
		saveButton.disabled = true;
	}
	const form = document.getElementById(formId);

	if (form.checkValidity()) {

		// Make request.
		const { origin } = window.location
		let url = `${origin}/include/ajax/${ajaxFilename}.php`;
		const formEntries = new FormData(form);

		try {
			const response = await fetch(url, {
				method: 'POST',
				body: formEntries,
			});
			if (!response.ok) {
				throw new Error(`Response status: ${response.status}`);
			}
			const jsonResponse = await response.json();

			// Close modal.
			const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(modalId));
			modal.hide();
			if (saveButton) {
				saveButton.disabled = false;
			}

			if (defaultInputNameObj?.inputName) {
			const inputElements = document.getElementsByName(defaultInputNameObj.inputName);
			if (inputElements.length && defaultInputNameObj?.formName) {
				[...inputElements].forEach((inputElement) => {
					if (inputElement.classList.contains('search-field') && inputElement.name === defaultInputNameObj.inputName) {
						const collectedFormNames = defaultInputNameObj.formName.split('+');
						const newValue = collectedFormNames.map((f) => `${formEntries.get(f)}`).join(' ');
						inputElement.value = newValue;
						// Also set the hidden input field with the new id.
						const inputIdElements = document.getElementsByName(`${defaultInputNameObj.inputName}id`);
						if (inputIdElements.length) {
							[...inputIdElements].forEach((inputIdElement) => {
								if (inputIdElement.classList.contains('search-field')) {
									// Should get the response Id as value.
									inputIdElement.value = jsonResponse;
									// A real id is now selected, so clear the "please select"
									// custom validity set while the field held free text,
									// otherwise checkValidity() fails on submit despite the
									// field looking valid (green).
									if (typeof inputElement.setCustomValidity === 'function') {
										inputElement.setCustomValidity('');
									}
									inputElement.classList.remove('is-invalid');
									inputElement.classList.add('is-valid');
								}
							})
						}
					}
				})
			}
		}

			// Clear the modal form so stale data isn't shown when it's reopened.
			form.reset();
			[...form.elements].forEach((element) => {
				element.classList.remove('is-valid', 'is-invalid');
				if (typeof element.setCustomValidity === 'function') {
					element.setCustomValidity('');
				}
			});
			form.classList.remove('was-validated');

		} catch (error) {
			console.error(error);
			if (errorElementId) {
				const errorElement = document.getElementById(errorElementId);
				if (errorElement) {
					const paragraphEl = document.createElement('p');
					paragraphEl.className = 'modal-error-text';
					paragraphEl.innerText = 'An error occured, check the input form and try again';
					errorElement.appendChild(paragraphEl);
					// Show a general error for 3 seconds.
					setTimeout(() => {
						errorElement.innerHTML = '';
					}, 3000);
				}
			}
			if (saveButton) {
				saveButton.disabled = false;
			}
		}
	} else {
		// Highlight elements that are required.
		[...form.elements].forEach(item => {
			if (!item.checkValidity()) {
				item.classList.add('is-invalid');
			}
		});
		if (saveButton) {
			saveButton.disabled = false;
		}
	}
}

// Attach functions to window object to make them globally accessible from the HTML.
window.onClickSaveButton = onClickSaveButton;
